export const CSRF_KEY = "anti-csrftoken-a2z";
